<div class="flex items-center gap-sm">
  <button
    type="button"
    (click)="onExpandAll()"
    [id]="idPrefix() + '_expand_all'"
    class="flex items-center font-medium text-sm py-sm px-lg border-none rounded-md gap-sm bg-transparent"
    [class.text-primary-500]="!isExpandDisabled()"
    [class.cursor-pointer]="!isExpandDisabled()"
    [class.text-neutral-400]="isExpandDisabled()"
    [disabled]="isExpandDisabled()">
    {{ expandLabel() | transloco }}
  </button>

  <button
    type="button"
    (click)="onCollapseAll()"
    [id]="idPrefix() + '_collapse_all'"
    class="flex items-center font-medium text-sm py-sm px-lg border-none rounded-md gap-sm bg-transparent"
    [class.text-primary-500]="!isCollapseDisabled()"
    [class.cursor-pointer]="!isCollapseDisabled()"
    [class.text-neutral-400]="isCollapseDisabled()"
    [disabled]="isCollapseDisabled()">
    {{ collapseLabel() | transloco }}
  </button>
</div>
